import { FixtureType, TournamentFormat } from '@/types/tournament.model';

/**
 * The structures each format can generate. The backend checks the same table on create
 * (TournamentModel.fixtureTypesFor): knockouts-only is a SHORT structure, since AMERICAN builds its
 * bracket from its groups, and the league (GROUPS_ONLY) belongs to LONG.
 */
const FIXTURE_TYPES_BY_FORMAT: Record<TournamentFormat, readonly FixtureType[]> = {
  [TournamentFormat.SHORT]: [FixtureType.GROUPS_AND_KNOCKOUTS, FixtureType.KNOCKOUTS],
  [TournamentFormat.AMERICAN]: [FixtureType.GROUPS_AND_KNOCKOUTS],
  [TournamentFormat.LONG]: [FixtureType.GROUPS_AND_KNOCKOUTS, FixtureType.GROUPS_ONLY],
};

export function isFixtureTypeAllowed(
  format: TournamentFormat,
  fixtureType: FixtureType,
): boolean {
  return FIXTURE_TYPES_BY_FORMAT[format].includes(fixtureType);
}

/**
 * The structure a draft keeps when its format changes: the current one when the new format can
 * generate it, otherwise groups + knockouts, which every format has.
 */
export function fixtureTypeForFormat(
  format: TournamentFormat,
  current: FixtureType | undefined,
): FixtureType {
  return current && isFixtureTypeAllowed(format, current)
    ? current
    : FixtureType.GROUPS_AND_KNOCKOUTS;
}
